import React, { useDebugValue } from 'react';
import moment from 'moment'

const NoneNat=({classes, samples, cu_numbers })=>{
    console.log(samples[0])
    //console.log(JSON.parse(cu_numbers))
    var numArr = samples[0].cu_numbers? (samples[0].cu_numbers).split(';') : []
    console.log(numArr)

    return (
        <table className={classes.fullTable}>
            <tbody>
                <tr>
                    <td>
                    <table className={classes.mainBody}>
                            <tbody >
                                <tr>
                                    <td style={{verticalAlign: 'top'}}>
                                    <table className={classes.tableStyle}  >
                                        <tbody>
                                            <tr>
                                                <td colSpan="6">
                                                Plasma Bleed Date: {moment(samples[0].bleed_date).format('MM/DD/yyyy')}
                                                </td>
                                            </tr>
                                            <tr><td colSpan="6">&nbsp;</td></tr>

                                            <tr>
                                                <td className={classes.uncTD}>
                                                { 
                                                // samples[0].isextra ===1 && cu_numbers? JSON.parse(cu_numbers).map(function(cu_number,index) {
                                                    samples[0].isextra ===1 ? numArr.map(function(cu_number,index) {
                                                
                                                    if(index >= 25) { return null };
                                                    return <div key={index} className={classes.uncDiv}>{cu_number.split(',')[0]}</div>
                                                    }) :
                                                cu_numbers? cu_numbers[0].map(function(cu_number,index) {
                                                 
                                                    if(index >= 25) { return null };
                                                    return <div key={index} className={classes.uncDiv}>{cu_number}</div>
                                                    }) : null
                                                }
                                                </td>
                                                <td className={classes.uncTD}>
                                                {
                                                //samples[0].isextra ===1 && cu_numbers? JSON.parse(cu_numbers).map(function(cu_number,index) {
                                                    samples[0].isextra ===1 ? numArr.map(function(cu_number,index) {
                                                    if(index < 25 || index >= 50 ) { return null };
                                                    return <div key={index} className={classes.uncDiv}>{cu_number.split(',')[0]}</div>
                                                    }) :
                                                cu_numbers? cu_numbers[0].map(function(cu_number,index) {
                                                    if(index < 25 || index >= 50 ) { return null };
                                                    return <div key={index} className={classes.uncDiv}>{cu_number}</div>
                                                    }) : null}
                                                </td>
                                                <td className={classes.uncTD}>
                                                {
                                                // samples[0].isextra ===1 && cu_numbers? JSON.parse(cu_numbers).map(function(cu_number,index) {
                                                    samples[0].isextra ===1 ? numArr.map(function(cu_number,index) {
                                                    if(index < 50 || index >= 75 ) { return null };
                                                    return <div key={index} className={classes.uncDiv}>{cu_number.split(',')[0]}</div>
                                                    }) :
                                                cu_numbers? cu_numbers[0].map(function(cu_number,index) {
                                                    if(index < 50 || index >= 75 ) { return null };
                                                    return <div key={index} className={classes.uncDiv}>{cu_number}</div>
                                                    }) : null}
                                                </td>
                                                <td className={classes.uncTD}>
                                                {
                                                 //samples[0].isextra ===1 && cu_numbers? JSON.parse(cu_numbers).map(function(cu_number,index) {
                                                    samples[0].isextra ===1 ? numArr.map(function(cu_number,index) {
                                                    if(index < 75 || index >= 100 ) { return null };
                                                    return <div key={index} className={classes.uncDiv}>{cu_number.split(',')[0]}</div>
                                                    }) :
                                                cu_numbers? cu_numbers[0].map(function(cu_number,index) {
                                                    if(index < 75 || index >= 100 ) { return null };
                                                    return <div key={index} className={classes.uncDiv}>{cu_number}</div>
                                                    }) : null}
                                                </td>
                                                <td className={classes.uncTD}>
                                                {
                                                //samples[0].isextra ===1 && cu_numbers? JSON.parse(cu_numbers).map(function(cu_number,index) {
                                                    samples[0].isextra ===1 ? numArr.map(function(cu_number,index) {
                                                    if(index < 100 || index >= 125 ) { return null };
                                                        return <div key={index} className={classes.uncDiv}>{cu_number.split(',')[0]}</div>
                                                    }) :
                                                cu_numbers? cu_numbers[0].map(function(cu_number,index) {
                                                    if(index < 100 || index >= 125 ) { return null };
                                                    return <div key={index} className={classes.uncDiv}>{cu_number}</div>
                                                    }) : null}
                                                </td>
                                                <td className={classes.uncTD}>
                                                {
                                                 //samples[0].isextra ===1 && cu_numbers? JSON.parse(cu_numbers).map(function(cu_number,index) {
                                                    samples[0].isextra ===1 ? numArr.map(function(cu_number,index) {
                                                    if(index < 125 || index >= 150 ) { return null };
                                                    return <div key={index} className={classes.uncDiv}>{cu_number.split(',')[0]}</div>
                                                    }) :
                                                cu_numbers? cu_numbers[0].map(function(cu_number,index) {
                                                    if(index < 125 || index >= 150 ) { return null };
                                                    return <div key={index} className={classes.uncDiv}>{cu_number}</div>
                                                    }) : null}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td>
                        <table className={classes.tableStyle}>
                        <tbody>
                            <tr>
                                <td width="50%">
                                    Date shipped: &nbsp;&nbsp;{moment(samples[0].ship_date).format('MM/DD/yyyy')}
                                </td>
                                <td>
                                    Time Removed from Storage for Shipment: &nbsp;&nbsp;{samples[0].time_removed}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                initial: &nbsp;&nbsp;{samples[0].init}
                                </td>
                                <td>
                                    Date: &nbsp;&nbsp;{moment(samples[0].init_date).format('MM/DD/yyyy')}
                                </td>
                            </tr>
                        </tbody>
                        </table>
                    </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                <td align="center">
                        <table className={classes.boxTable}>
                        <tbody>
                            <tr>
                                <td>
                                    <table className={classes.freeStyle}>
                                        <tbody >
                                            <tr>
                                                <td colSpan="5">&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td style={{width:"3px"}}>&nbsp;</td>
                                                <td colSpan="4">
                                                    <u><b>Lab Use Only:</b></u>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="5">&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td>Packed Properly:</td>
                                                <td>&#9744;&nbsp;&nbsp;Yes&nbsp;&nbsp;&nbsp;&#9744;&nbsp;&nbsp;No</td>
                                                <td colSpan="2">&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td colSpan="5">&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td>Initial:</td>
                                                <td>__________________________</td>
                                                <td>Date:</td>
                                                <td>__________________________</td>
                                            </tr>
                                            <tr>
                                                <td colSpan="5">&nbsp;</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                   
                                </td>
                            </tr>
                        </tbody>
                        </table>
                    </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
            </tbody>

        </table>
    )
}

export default NoneNat

